
import Vue from 'vue'
import axios from 'axios'
import XTable from 'vux/src/components/x-table/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import InlineXSwitch from 'vux/src/components/inline-x-switch/index.vue'
import XTextarea from 'vux/src/components/x-textarea/index.vue'
import XDialog from 'vux/src/components/x-dialog/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import Group from 'vux/src/components/group/index.vue'
import Selector from 'vux/src/components/selector/index.vue'

var CostExpensePage = Vue.extend({})
Vue.component('costExpense-page', CostExpensePage)

export default {
  name: 'CostExpensePage',
  directives: {
    TransferDom
  },
  components: {
    XTable,XButton,XInput,InlineXSwitch,XTextarea,XDialog,Group,Selector
  },
  props: {
    saveStatus: Number
  },
  data () {
    return {
      baseUrl: this.$store.state.url,
      flowId: '08c4a7eccfdb4efa9ba2c8c12e8f81fa',
      operatorId: '',//当前 操作人
      refModule: '',
      refRecordId: '',
      stepId: '',
      info: {},
      togetherName: '',//同行人
      tripRemark: '',//出差事由
      name: '',//费用名称
      isDeduction: false,//是否用于抵扣费用报销(不计入成本)
      isDeductionVal: 0,//是否用于抵扣费用报销(不计入成本)
      remark: '',//备注
      fileObj: {},//上传附件集合
      fileShowList: [],//上传附件集合-预览
      uploadedFileIdList: [],//已上传附件ID集合
      oldRefRecordIds: '',//对应文件记录，明细ID字符串

      showToast: false,//弹窗-dialog
      confirmBtn: false,// 控制显示、隐藏 确认提交按钮

      // 责任中心
      treeData: [],//组织结构树
      checkTreeShow: false,
      checkTreeSearchVal: '',//组织结构树搜索内容
      checkTreeSearchResult: [],//组织结构树搜索结果
      treeProps: {
        children: 'children',
        label: 'name'
      },
      checkDeptResultName: '',//责任中心name
      checkDeptResult: {},//责任中心-选择结果
      // 责任中心-END

      //所属业务
      businessShow: false,
      businessName: '',//dialog-业务名称
      selectorList: [],//dialog-业务类型
      selectorValue: '',//dialog-业务类型-val

      preStatus: true,
      nextStatus: false,

      businessList: [],//dialog-业务搜索结果
      businessNameList: [],//dialog-业务搜索结果
      businessAllNum: '',//dialog-业务总个数
      businessChoosed: {},//dialog-选择的业务
      pageNum: 1,//dialog-业务搜索结果-页码
      switchValue: false,//dialog-选择业务switch
      //所属业务-END

      //报销明细
      expenseShow: false,
      feeRemark: '',//费用类型及说明
      money10: '',//报销费用
      money11: '',//财务核实金额列
      expenseCostItemsList: [],//成本科目list
      expenseCostItemsVal: '',//成本科目val
      expenseCostTypeList: [],//成本类型list
      expenseCostTypeVal: '',//成本类型val
      isEInvoice: false,//是否电子发票
      isEInvoiceVal: 0,//是否电子发票
      eleInvoiceNo: '',//发票号码
      falDepAudit: false,//计入部门考核
      falDepAuditVal: 0,//计入部门考核

      savedList: {},//成功保存后，返回的明细list
      savedObj: {},//成功保存后，返回的明细Obj
      total1: '',//费用合计
      total2: '',//费用合计大写
      deductMoney: '',//本次抵扣金额
      btnText: '增加',
      //报销明细-END

      //借款抵消
      saveMoneyJKDXShow: false,
      loanList: [],//借款单
      businessJKDXChoosed: {},//dialog借款单选择radio
      businessOffsetListRadio: [],//借款抵消展示列表明细id
      businessOffsetRadioVal: {},//借款抵消展示列表选中行-内容
      savedJKDXList: [],//借款抵消明细保存后返回的list数组,供删除时使用
      savedJKDXObj: {},//借款抵消明细保存后返回的obj数组,供删除时使用
      departLoanMoney: '',//部门未归还金额
      applicantLoanMoney: '',//个人未归还金额
      shouldPayShow: '',//应付金额
      //借款抵消-END

      //收款人信息
      payUnitName: '',//收款人/单位
      bank: '',//收款银行
      bankAccount: '',//bankAccount
      //收款人信息-END

    }
  },
  mounted () {
    this.axios({
      url: this.baseUrl+'/wechat/expense/modExpense?flowId='+this.flowId+'&type=2',
      method: 'get'
    }).then((response) => {
      this.info = response.data.obj;
      this.refRecordId = response.data.refRecordId;
      this.refModule = response.data.refModule;
      this.operatorId = response.data.operatorId;
    }).catch((response) => {
      this.$vux.loading.hide();
    });
    this.$emit('sendTitleToParent','报销申请-费用报销');
  },
  methods: {
    showMsg (msg) {
      this.$vux.alert.show({
        title: msg
      });
      setTimeout(() => {
        this.$vux.alert.hide();
      }, 2000)
    },
    openDialog (v) {// 打开选择业务-dialog
      this.checkTreeShow = false;
      this.businessShow = false;
      this.expenseShow = false;
      this.saveMoneyJKDXShow = false;
      this.showToast = true;
      if(v == 'deptTree'){//责任中心
        this.checkDeptResult = [];
        this.getDeptTree();
      }else if(v == 'business'){//所属业务
        this.businessShow = true;
        this.getBusinessList();
        this.searchBusiness();
      }else if(v == 'expense'){//报销明细
        this.getExpenseCostItems();
        this.getExpenseCostType();
        this.expenseShow = true;
      }else if(v == 'jkdx'){//借款抵消
        this.getlistLoanBusinessNewBX();
        this.saveMoneyJKDXShow = true;
      }
    },
    confirmDialog (v) {
      console.log('confirmDialog',v);
    },
    switchVal (data) {//switch
      if(data){
        this.isDeductionVal = 1;
      }else{
        this.isDeductionVal = 0;
      }
    },
    chooseFile () {// 选择附件
      // let that = this;
      this.fileObj = document.getElementById('file').files;
      // let fileL = document.getElementById('file').files.length;
      // for(let i=0;i<fileL;i++){
      //   let file = document.getElementById('file').files[i];
      //   let reader = new FileReader();
      //   reader.readAsDataURL(file);
      //   reader.onload=function(e) {
      //     that.fileShowList.push(this.result);
      //   }
      // }
      this.$vux.loading.show({
        text: '保存中'
      });
      this.submitFile();
    },
    deleteFile (index) {// 删除已选附件
      this.fileShowList.splice(index,1);

      let deleteFileId = this.uploadedFileIdList[index];
      let fileData = new FormData();
      fileData.append("fileId",deleteFileId);

      this.axios({
        url: this.baseUrl+'/wechat/commonFile/deleteFile',
        method: 'post',
        data: fileData
      }).then((response) => {
        console.log('费用报销deleteFile',response);
        this.uploadedFileIdList.splice(index,1);
      }).catch((response) => {
        this.$vux.loading.hide();
      });

    },
    async submitFile () {// 上传附件-图片
      let fileObjL = this.fileObj.length;
      for(let i=0;i<fileObjL;i++){
        let fileData = new FormData();
        fileData.append("file",this.fileObj[i]);
        fileData.append("taskId",this.info.id);
        fileData.append("refRecordId",this.savedList.id);
        fileData.append("refModule",this.refModule);
        fileData.append("stepId",this.stepId);
        fileData.append("operatorId",this.operatorId);
        fileData.append("expenseType",this.info.type);
        fileData.append("flowId",this.flowId);

        let res = await this.axios({
          url: this.baseUrl+'/wechat/commonFile/uploadFile',
          method: 'post',
          data: fileData
        });
        this.uploadedFileIdList.push(res.data.fileId);
      }

      let that = this;
      let fileL = document.getElementById('file').files.length;
      for(let i=0;i<fileL;i++){
        let file = document.getElementById('file').files[i];
        let reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload=function(e) {
          that.fileShowList.push(this.result);
        }
      }
      this.$vux.loading.hide();
    },
    getDeptTree () {//责任中心-获取组织架构
      this.axios({
        url: this.baseUrl+'/wechat/commonInterface/deptTree',
        method: 'get'
      }).then((response) => {
        this.treeData = response.data;
        this.checkTreeShow = true;
      }).catch((response) => {
        this.$vux.loading.hide();
      });
    },
    treeSearch () {//提交-组织架构搜索按钮
      this.checkTreeSearchResult = [];
      let checkTreeSearchVal = this.checkTreeSearchVal;
      let treeData = this.treeData;
      if(checkTreeSearchVal!=''){
        this.getArray(treeData,checkTreeSearchVal);
      }
    },
    getArray (data,name) {//组织架构搜索-递归
      for (var i in data) {
        if (data[i].name == name || data[i].name.indexOf(name) != -1) {
          this.checkTreeSearchResult.push(data[i]);
        }else {
          this.getArray(data[i].children, name);
        }
      }
    },
    addToTree (item) {//将搜索结果添加到树
      let CheckedNodes = this.$refs.tree.getCheckedNodes();
      CheckedNodes.push(item);
      this.$refs.tree.setCheckedNodes(CheckedNodes);
      this.checkTreeSearchResult = [];
    },
    clearSearchResult () {//清空搜索栏
      this.checkTreeSearchResult = [];
    },
    getCheckedNodes() {//审批-组织架构树

      let checkedPersonArr = this.$refs.tree.getCheckedNodes();

      this.checkDeptResult = checkedPersonArr[0];
      this.checkDeptResultName = this.checkDeptResult.name;
      this.checkTreeShow = false;//隐藏责任中心part
      this.showToast = false;//关闭dialog
      console.log('组织架构树',this.checkDeptResult);
    },
    clearDeptResult () {//清除组织架构
      this.checkDeptResultName = '';
      this.checkDeptResult = {};
    },
    async getBusinessList () {
      let res = await this.axios({
        url: this.baseUrl+'/wechat/commonInterface/listRefFlowTypes',
        method: 'get'
      });
      this.selectorList = res.data.list;
    },
    async searchBusiness () {// dialog-搜索业务
      this.businessList = [];
      let res = await this.axios({
        url: this.baseUrl+'/wechat/commonInterface/businessList?businessName='+this.businessName+'&flowType='+this.selectorValue+'&page='+this.pageNum+'&rows=15',
        method: 'get'
      });
      console.log(res)
      this.$vux.loading.hide();
      this.businessList = res.data.list;
      let businessLength = res.data.list.length;
      for(let i=0;i<businessLength;i++){
        this.businessNameList.push(res.data.list[i].businessName);
      }
      this.businessAllNum = Math.ceil(res.data.total/15);
    },
    getPrePage () {//dialog-上一页
      if(this.pageNum == 1){
        this.preStatus = true;
      }else{
        this.businessChoosed = {};
        this.nextStatus = false;
        this.pageNum--;
        this.searchBusiness();
      }
    },
    getNextPage () {//dialog-下一页
      if(this.pageNum == this.businessAllNum){
        this.nextStatus = true;
      }else{
        this.businessChoosed = {};
        this.preStatus = false;
        this.pageNum++;
        this.searchBusiness();
      }
    },
    chooseBusiness () {//dialog-确定
      this.showToast = false;
    },
    clearBusiness () {// 清除业务
      this.businessChoosed = {};
    },
    async getExpenseCostItems () {//报销明细-获取成本科目
      let res = await this.axios({
        url: this.baseUrl+'/wechat/commonInterface/getCostItems',
        method: 'get'
      });

      this.expenseCostItemsList = res.data.list;
    },
    async getExpenseCostType () {//报销明细-获取成本类型
      let res = await this.axios({
        url: this.baseUrl+'/wechat/commonInterface/getBaseCostitemsBudgets',
        method: 'get'
      });

      this.expenseCostTypeList = res.data.list;
    },
    switchEInvoice (data) {//switch
      if(data){
        this.isEInvoiceVal = 1;
      }else{
        this.isEInvoiceVal = 0;
      }
    },
    switchFalDepAudit (data) {//switch
      if(data){
        this.falDepAuditVal = 1;
      }else{
        this.falDepAuditVal = 0;
      }
    },
    expenseSave(){//报销明细-保存
      this.$vux.loading.show({
        text: '保存中'
      });
      let formData = new FormData();
      if(this.btnText == '修改'){
        formData.append("id",this.savedList.id);
      }
      formData.append("businessId",this.info.id);
      formData.append("type",'2');
      formData.append("feeRemark",this.feeRemark);
      formData.append("money10",this.money10);
      formData.append("money11",this.money11);
      formData.append("itemsId",this.expenseCostItemsVal);
      formData.append("itemsTypeId",this.expenseCostTypeVal);
      formData.append("isEInvoice",this.isEInvoiceVal);
      formData.append("eleInvoiceNo",this.eleInvoiceNo);
      formData.append("falDepAudit",this.falDepAuditVal);

      this.axios({
        url: this.baseUrl+'/wechat/expense/saveMoneyBX',
        method: 'post',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8'
        },
        data: formData
      }).then((response) => {
        this.$vux.loading.hide();
        console.log('dialog-报销明细-保存',response.data);
        if(response.data.status == 1){//保存成功
          this.savedList = response.data.list[0];
          this.total1 = response.data.total;
          this.total2 = response.data.total2;
          this.shouldPayShow = response.data.total3;
          this.savedObj = response.data.obj;
          this.btnText = '修改';
        }else{
          this.showMsg(response.data.error);
        }

        this.showToast = false;
        this.$common.showToastMsg(response.data.success);
      }).catch((response) => {
        this.$vux.loading.hide();
      });
    },
    expenseDelete (){//报销明细-删除
      this.$vux.loading.show({
        text: '正在删除'
      });
      let formData = new FormData();
      formData.append("id",this.savedList.id);
      formData.append("businessId",this.info.id);

      this.axios({
        url: this.baseUrl+'/wechat/expense/delMoneyBx',
        method: 'post',
        data: formData
      }).then((response) => {
        this.$vux.loading.hide();
        console.log('dialog-报销明细-删除',response.data);
        if(response.data.status == 1){//删除成功
          this.btnText = '增加';
          this.savedList = {};
          this.total1 = '';
          this.total2 = '';
          this.shouldPayShow = '';
        }
        this.showToast = false;
      }).catch((response) => {
        this.$vux.loading.hide();
      });
    },
    async getlistLoanBusinessNewBX(){//获取借款单
      let res = await this.axios({
        url: this.baseUrl+'/wechat/loan/listLoanBusinessNewBX?expenseId='+this.info.id+'&loanStatus=2&',
        method: 'get'
      });
      console.log('获取借款单',res.data);
      this.loanList = res.data.list;

    },
    businessJKDXSave(){//抵消借款
      console.log('businessJKDXSave',this.businessJKDXChoosed);
      if(this.businessJKDXChoosed.id){//选择了某项明细

        let choosedId = this.businessJKDXChoosed.id;//所选抵消明细id
        let savedList = this.businessOffsetListRadio;
        for(let i=0;i<savedList.length;i++){
          if(savedList[i].id==choosedId){//如果已存在，则返回false
            this.showToast = false;
            return false;
          }
        }

        this.$vux.loading.show({
          text: '保存中'
        });
        let formData = new FormData();
        formData.append("id",'');
        formData.append("loanBusinessId",this.businessJKDXChoosed.id);
        formData.append("loanBusinessName",this.businessJKDXChoosed.businessName);
        formData.append("expenseId",this.info.id);
        formData.append("applyName",this.businessJKDXChoosed.applicantName);
        formData.append("applyDate",this.businessJKDXChoosed.fill_date);
        formData.append("businessName",this.businessJKDXChoosed.businessName);
        formData.append("loanMoney",this.businessJKDXChoosed.loan_money);
        formData.append("noPaymentMoney",this.businessJKDXChoosed.no_payment_money);
        formData.append("loanReason",this.businessJKDXChoosed.loan_reason);
        formData.append("deductMoney",this.deductMoney);
        formData.append("remark",'');

        this.axios({
          url: this.baseUrl+'/wechat/expense/saveMoneyJKDX',
          method: 'post',
          data: formData
        }).then((response) => {
          this.$vux.loading.hide();
          console.log('dialog-抵消明细-保存',response.data);
          if(response.data.status == 1){//保存成功
            this.showMsg(response.data.success);
            this.savedJKDXList = response.data.list;
            this.savedJKDXObj = response.data.obj;
            this.departLoanMoney = response.data.departLoanMoney;
            this.applicantLoanMoney = response.data.applicantLoanMoney;
            this.shouldPayShow = this.savedJKDXObj.shouldPay;//应付金额赋值

            this.businessOffsetListRadio=response.data.list;
            console.log('抵扣明细用来展示的数组',this.businessOffsetListRadio);
            this.showToast = false;
          }

        }).catch((response) => {
          this.$vux.loading.hide();
        });


      }
    },
    businessJKDXDelete(){//抵消借款-删除所选抵消明细

      let formData = new FormData();
      formData.append("id",this.savedJKDXList[this.businessOffsetRadioVal].id);
      formData.append("expenseId",this.info.id);

      this.axios({
        url: this.baseUrl+'/wechat/expense/delMoneyJKDX',
        method: 'post',
        data: formData
      }).then((response) => {
        this.$vux.loading.hide();
        console.log('dialog-抵消明细-删除',response.data);
        if(response.data.status == 1){//保存成功
          this.showMsg(response.data.success);
          this.shouldPayShow = response.data.obj.shouldPay;
          this.departLoanMoney = response.data.departLoanMoney;
          this.applicantLoanMoney = response.data.applicantLoanMoney;
          this.businessOffsetListRadio.splice(this.businessOffsetRadioVal, 1);//删除该条数据
          this.savedJKDXList.splice(this.businessOffsetRadioVal, 1);//删除该条数据
        }

      }).catch((response) => {
        this.$vux.loading.hide();
      });

    },
    changeMoney11(){
      this.money11 = this.money10;
    },
    getDeductMoney(v){//获取输入抵消借款-失去焦点时保存
      console.log('getDeductMoney',this.businessOffsetListRadio[v],this.$refs['deductMoney'+v][v]['currentValue'],v);
      this.$vux.loading.show({
        text: '保存中'
      });
      let tempDeductMoney = this.$refs['deductMoney'+v][v]['currentValue'];
      let formData = new FormData();
      formData.append("id",this.businessOffsetListRadio[v].id);
      formData.append("loanBusinessId",this.businessOffsetListRadio[v].loanBusinessId);
      formData.append("loanBusinessName",this.businessOffsetListRadio[v].loanBusinessName);
      formData.append("expenseId",this.info.id);
      formData.append("applyName",this.businessOffsetListRadio[v].applyName);
      formData.append("applyDate",this.businessOffsetListRadio[v].applyDate);
      formData.append("businessName",this.businessOffsetListRadio[v].businessName);
      formData.append("loanMoney",this.businessOffsetListRadio[v].loanMoney);
      formData.append("noPaymentMoney",this.businessOffsetListRadio[v].noPaymentMoney);
      formData.append("loanReason",this.businessOffsetListRadio[v].loanReason);
      formData.append("deductMoney",tempDeductMoney);

      this.axios({
        url: this.baseUrl+'/wechat/expense/saveMoneyJKDX',
        method: 'post',
        data: formData
      }).then((response) => {
        this.$vux.loading.hide();
        console.log('dialog-抵消明细-修改抵消借款后保存',response.data);
        if(response.data.status == 1){//保存成功
          this.showMsg(response.data.success);
          this.savedJKDXList = response.data.list;
          this.savedJKDXObj = response.data.obj;
          this.departLoanMoney = response.data.departLoanMoney;
          this.shouldPayShow = this.savedJKDXObj.shouldPay;//应付金额赋值
        }else{
          this.showMsg(response.data.error);
          this.$refs['deductMoney'+v][v]['currentValue'] = '';
        }

      }).catch((response) => {
        this.$vux.loading.hide();
      });
    },
    saveForm () {//保存
      if(this.name == ''){
        this.showMsg('请补充必填信息');
        return false;
      }
      this.$vux.loading.show({
        text: '加载中'
      });

      let formData = new FormData();
      formData.append("flowId",this.info.flowId);
      formData.append("staffId",this.info.staffId);
      formData.append("id",this.info.id);
      formData.append("recCode",this.info.recCode);
      formData.append("name",this.name);
      formData.append("togetherName",this.togetherName);
      formData.append("tripRemark",this.tripRemark);
      formData.append("isDeduction",this.isDeductionVal);
      formData.append("remark",this.remark);
      formData.append("type",this.info.type);

      if(this.businessChoosed.id){
        formData.append("businessReport",this.businessChoosed.reportNo);
        formData.append("flowType",this.businessChoosed.flowType);
        formData.append("businessId",this.businessChoosed.id);
        formData.append("businessName",this.businessChoosed.businessName);
      }

      if(this.checkDeptResult.id){
        formData.append("centerDepartmentId",this.checkDeptResult.id);
        formData.append("centerDepartmentName",this.checkDeptResult.name);
      }

      formData.append("userPeopleId",this.info.userPeopleId);
      formData.append("userPeopleName",this.info.userPeopleName);
      formData.append("userDepartId",this.info.userDepartId);
      formData.append("userDepartName",this.info.userDepartName);
      formData.append("applyDate",this.info.applyDate);
      formData.append("jibie",this.info.jibie);
      formData.append("payUnitName",this.payUnitName);
      formData.append("bank",this.bank);
      formData.append("bankAccount",this.bankAccount);
      formData.append("total1",this.total1);
      formData.append("total2",this.total2);

      if(this.savedJKDXObj.loanTotal){
        formData.append("loanTotal",this.savedJKDXObj.loanTotal);
        formData.append("shouldPay",this.savedJKDXObj.shouldPay);
      }

      axios({
        url: this.baseUrl+'/wechat/expense/saveForm',
        method: 'post',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/x-www-form-urlencoded'
        },
        data: formData,
      }).then((response) => {
        console.log('费用报销saveForm',response.data,this.saveStatus);
        if(response.data.status == 0){//保存失败
          this.$vux.loading.hide();
          this.showMsg(response.data.msg);
        }else if(this.saveStatus == 0&&response.data.status == 1){//父组件操作发起，并且保存成功
          this.startFlow();
        }else if(this.saveStatus == 1&&response.data.status == 1){//父组件操作提交，并且保存成功
          this.$emit('sendStatusToParent',{status:1});
          this.$vux.loading.hide();
        }

      }).catch((response) => {
        this.$vux.loading.hide();
      });
    },
    startFlow () {//发起
      let startData = new FormData();
      startData.append("id",this.info.id);
      startData.append("flowId",this.info.flowId);
      startData.append("staffId",this.info.staffId);
      this.axios({
        url: this.baseUrl+'/wechat/expense/startFlow',
        method: 'post',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8'
        },
        data: startData
      }).then((response) => {
        console.log('费用报销startFlow',response.data);
        this.showMsg('保存成功！请继续完成提交操作！');

        if(response.data.status == 1){

          this.$emit('sendStatusToParent',{
            status:0,
            id:response.data.taskId,
            stepId:response.data.stepId
          });
        }
        this.$vux.loading.hide();
      }).catch((response) => {
        this.$vux.loading.hide();
      });

    }
  }
}



// WEBPACK FOOTER //
// ./src/components/launch/finance/costExpense.vue